<template>
    <span style="display: inline-block">
        <span class="span-select flex flex-nowrap items-center" @click.stop.prevent="open">
            <span v-if="value">{{ text }}</span>
            <span class="empty-fillable" v-else />
            <vx-action-icon class="ml-1" :size="5" icon="ChevronDownIcon" />
        </span>

        <div
            v-if="isOpen"
            class="vs-dropdown--menu absolute mt-2 flex flex-col"
            ref="menu"
            v-click-outside="close"
        >
            <vx-scroll-area style="max-height: 300px">
                <vs-dropdown-item
                    v-for="(option, index) in options"
                    :key="index"
                    class="dd-item"
                    style="width: 97%"
                    @click="select(option)"
                >
                    <slot name="item" :option="option">
                        {{ getText(option) }}
                    </slot>
                </vs-dropdown-item>
                <template v-if="clearable">
                    <vs-divider class="my-1"></vs-divider>
                    <vs-dropdown-item @click="clear"> Clear </vs-dropdown-item>
                </template>
            </vx-scroll-area>
        </div>
    </span>
</template>

<script>
import VxScrollArea from './VxScrollArea.vue'
import ClickOutside from 'vue-click-outside'

export default {
    name: 'vx-span-select',
    components: { VxScrollArea },
    directives: { ClickOutside },
    props: {
        value: {
            type: null
        },
        options: {
            type: Array,
            default: () => []
        },
        valueKey: {
            type: null
        },
        textKey: {
            type: null
        },
        clearable: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isOpen: false
        }
    },
    computed: {
        text() {
            if (this.value) {
                return this.getText(this.value)
            }
        }
    },
    methods: {
        open() {
            this.isOpen = true
        },
        close() {
            this.isOpen = false
        },
        clear() {
            this.close()
            this.$emit('input', null)
        },
        select(val) {
            this.close()
            this.$emit('input', val)
        },
        getText(item) {
            if (typeof item === 'object') {
                if (this.textKey) {
                    if (typeof this.textKey === 'function') {
                        return this.textKey(item)
                    }
                    return item[this.textKey]
                }
                return item[this.valueKey]
            }
            return item
        },
        getValue(item) {
            if (this.valueKey && typeof item === 'object') {
                return item[this.valueKey]
            }
            return item
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .vs-con-dropdown_x {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;
}
.vs-dropdown--menu {
    z-index: 1000;
}
.dd-item :deep(a) {
    text-decoration: none;
    transition: none;
}
.empty-fillable {
    display: inline-block;
    width: 150px;
    &::before {
        content: '\200B'; /* Insert a zero-width space character to ensure the span has some content */
    }
    border-bottom: 1px solid rgba(var(--vs-light), 1);
}
.span-select {
    cursor: pointer;
}
</style>
